module.exports = __webpack_public_path__ + "img/日産.15702e4a.png";